import styled from 'styled-components';
import { Typography } from 'antd';
import { CSSProperties } from 'react';
import { colors, fonts, sizes, breakpoints } from '../../theme';

export const SectionContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${sizes.gap.xl};
  padding: ${sizes.spacing.xl} ${sizes.padding.lg};
  box-sizing: border-box;

  ${breakpoints.media.mobile} {
    gap: ${sizes.gap.lg};
    padding: ${sizes.spacing.lg} ${sizes.padding.sm};
  }
`;

export const titleStyle: CSSProperties = {
  color: colors.primary,
  fontFamily: fonts.families.secondary,
  fontSize: '3rem',
  fontWeight: fonts.weights.bold,
  letterSpacing: fonts.letterSpacing.wide,
  margin: 0,
  textAlign: 'center',
};

export const SectionTitle = styled(Typography.Title)`
  ${breakpoints.media.mobile} {
    &.ant-typography {
      font-size: 2rem !important;
    }
  }
`;
